<template>
  <div class="c-app flex-row align-items-center">
    <CContainer class="col-md-7">
      <CRow class="justify-content-center">
        <CCol col="8">
          <CCardGroup>
            <CCard class="p-4" v-if="show_email_login || !IS_MZ_BRANDING">
              <CCardBody>
                <CForm @submit.prevent="handleLogin">
                  <div class="d-flex flex-row justify-content-between">
                    <h1>
                      {{ loginText.loginTitle }}
                    </h1>
                    <CSelect
                      class="mt-3 mt-auto"
                      :value="$store.state.language"
                      :options="languages"
                      @update:value="setLanguage"
                    />
                  </div>
                  <p class="text-muted">
                    {{loginText.signIn}}
                  </p>
                  <CInput
                      :placeholder="loginText.usernamePlaceholder"
                      autocomplete="username email"
                      v-model="login"
                      name="login"
                      class="mb-2"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-user"/>
                    </template>
                  </CInput>
                  <CInput
                      :placeholder="loginText.passwordPlaceholder"
                      type="password"
                      autocomplete="current-password"
                      v-model="password"
                      name="password"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked"/>
                    </template>
                  </CInput>
                  <CRow class="mt-2">
                    <CCol col="6" class="text-left">
                      <CButton
                        color="primary"
                        class="px-4"
                        type="submit"
                        data-cy=login-button
                      >
                          {{loginText.loginButton}}
                      </CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton
                          color="link"
                          class="px-0"
                          to="/account/forgot"
                          data-cy="forgot-password-link"
                      >
                        {{loginText.forgotPassword}}
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
                v-else
                color="primary"
                text-color="white"
                class="text-center py-5"
                body-wrapper
            >
              <CCardBody>
                <div class="login-left">
                  <form action="." method="post" class="flex-2">
                    <div class="center-box">
                      <div>
                        <h2>Login</h2>
                        <p class="text-muted">{{loginText.signIn}}</p>
                        <div class="card-body">
                          <a :href="mzAuthUri" class="btn btn-lg btn-secondary px-4 text-center">
                            <div v-if="oauthLoading">
                              <CSpinner/>
                            </div>
                            <div v-else>
                              <img src='/img/mz_logo.png' alt='' class='img-responsive' style='max-width: 100px'>
                              <div>
                                {{loginText.signIn}} via
                                <br>
                                Mazars The Gate™
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <LoginRight/>
  </div>
</template>

<script>
import { request } from '@/utils/request';
import { API_ENDPOINTS } from '@/constants/common';
import { ActiveUser } from '@/services/user';
import { IS_MZ_BRANDING } from '@/constants/config';
import { AuthService } from '@/services/auth';
import LoginRight from '@/components/LoginRight';
import loginTranslations from "../../constants/loginTranslations";
import { LanguageMixin } from "@/mixins/language";

export default {
  name: 'Login',
  components: { LoginRight },
  mixins: [LanguageMixin],
  props: ['show_email_login'],
  data: function () {
    return {
      IS_MZ_BRANDING,
      login: '',
      password: '',
      mzAuthUri: '',
      oauthLoading: false,
      loginText: this.getTranslations(),
    };
  },
  mounted() {
    this.redirectAuthenticated();
    this.tryLoginWithAccessCode();
    if (IS_MZ_BRANDING) {
      this.fetchMzAuthUri();
    }
  },
  methods: {
    setLanguage(language) {
      this.$store.commit("set", ["language", language]);
      this.loginText = this.getTranslations()
    },
    getTranslations() {
        return this.$store.state.language === 'fr' ? loginTranslations.fr : loginTranslations.en;
    },
    redirectAfterLogin() {
      const pathToLoadAfterLogin = localStorage.getItem('pathToLoadAfterLogin');
      localStorage.removeItem('pathToLoadAfterLogin');
      this.$router.replace((!pathToLoadAfterLogin?.includes("login") && pathToLoadAfterLogin) || '/');
    },
    redirectAuthenticated() {
      if (ActiveUser.get()) this.redirectAfterLogin()
    },
    async tryLoginWithAccessCode() {
      const { code, state } = this.$route.query;
      if (code && state) {
        this.oauthLoading = true;
        const { data } = await request({
          url: API_ENDPOINTS.mzAuthCallback,
          query: {
            code,
            state,
          },
        });
        await ActiveUser.setToken(data.access_token);
        this.redirectAfterLogin()
      }
    },
    async fetchMzAuthUri() {
      const { data } = await request({
        url: API_ENDPOINTS.mzAuth,
      });
      this.mzAuthUri = data.authorization_url;
    },
    async handleLogin() {
      const { res } = await AuthService.login({
        email: this.login,
        password: this.password,
      });
      if (res.status !== 200) {
        return alert(this.$t('Login failed'), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
      }
      this.redirectAuthenticated();
    },
  },
};
</script>

<style scoped lang="scss">
.hidden-input {
  display: none;
}
</style>
